import { ApiKeyConst } from "../constants/api-key.constants";
import {
  ApiKeyStatusEnum,
  type ICreateApiKeyDto,
} from "../dto/api-keys/api-keys.dto";
import type { IRoleDropdownItem } from "../dto/report/report-admin.dto";
import type { ISelectListItem } from "../models/common.models";

export const formatApiKeyTokenTail = (tokenTail: string): string =>
  `${ApiKeyConst.TOKEN_TAIL_PREFIX}${tokenTail}`;

// An expired key can still be revoked: revoking also removes its hidden user.
export const isApiKeyRevocable = (status: ApiKeyStatusEnum): boolean =>
  status !== ApiKeyStatusEnum.Revoked;

export const toApiKeyCompanySelectItems = (
  companies: { id: number; name: string }[],
): ISelectListItem[] =>
  companies.map(company => {
    const item: ISelectListItem = { value: company.id, label: company.name };

    return item;
  });

// Global roles are templates every company can grant, so they are marked to tell them apart.
export const toApiKeyRoleSelectItems = ({
  roles,
  globalSuffix,
}: {
  roles: IRoleDropdownItem[];
  globalSuffix: string;
}): ISelectListItem[] =>
  roles.map(role => {
    const item: ISelectListItem = {
      value: role.id,
      label: role.companyId ? role.name : `${role.name} (${globalSuffix})`,
    };

    return item;
  });

export const toCreateApiKeyDto = ({
  companyId,
  name,
  roleId,
  ttlDays,
}: {
  companyId: number | string;
  name: string;
  roleId: number | string;
  ttlDays: number | string;
}): ICreateApiKeyDto => {
  const dto: ICreateApiKeyDto = {
    companyId: Number(companyId),
    name: name.trim(),
    roleId: Number(roleId),
    ttlDays: Number(ttlDays),
  };

  return dto;
};
